import { useMutation } from '@tanstack/react-query';
import { useSelectedStore } from '@web/app/shared';

import { useWebCoreStore } from '../stores';

type HandleSuccessEventFunc = (value?: any) => void;

type HandleErrorEventFunc = (error?: Error) => void;

export const useLogout = (handleSuccessEvent?: HandleSuccessEventFunc, handleErrorEvent?: HandleErrorEventFunc) => {
    const logout = useWebCoreStore(state => state.logout);
    const reset = useSelectedStore(state => state.clearSelection);
    return useMutation({
        mutationKey: ['LOGOUT_USER'],
        mutationFn: async () => {
            await logout();
            reset();
        },
        onSuccess(data) {
            handleSuccessEvent && handleSuccessEvent(data);
        },
        onError(error) {
            handleErrorEvent && handleErrorEvent(error);
        },
    });
};
